import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import { DEFAULT_SIZE, DEFAULT_THEME, DEFAULT_THICKNESS } from '../../configs';
import type { TSizeStyles, TSizes, TThemeStyles, TThemes } from '../../models';

import type { TSpinner } from './models';

export const Spinner: FC<TSpinner> = ({
    className,
    dataTestId = 'spinner',
    id,
    marginLeft,
    marginRight,
    size = DEFAULT_SIZE,
    styles,
    theme = DEFAULT_THEME,
    thickness = DEFAULT_THICKNESS,
}) => (
    <div
        className={cn(
            styles.container,
            {
                [styles.marginLeft]: marginLeft,
                [styles.marginRight]: marginRight,
            },
            styles[`size-${size}` as TSizeStyles[TSizes]],
            className
        )}
        data-test-id={dataTestId}
        id={id}
    >
        <svg className={styles.spinner} viewBox="0 0 50 50">
            <circle
                className={cn(styles.path, styles[`theme-${theme}` as TThemeStyles[TThemes]])}
                cx="25"
                cy="25"
                fill="none"
                r="20"
                strokeWidth={thickness}
            />
        </svg>
    </div>
);
